<template>
    <quiz-container 
        :loading="loading"
        :hideExit="true"
    />
</template>

<script>
    import { mapGetters } from 'vuex';
    import QuizContainer from './quiz-container.vue';

    export default {
        components: {
            QuizContainer,
        },
        data() {
            return {
                loading: true,
                iABRef: null,
            }
        },
        computed: {
            ...mapGetters({
                currentQuiz: 'quizzes/current',
                user: 'auth/getUser',
            })
        },
        created() {
            //If no url, go back
            if(!this.currentQuiz.quiz_url) {
                this.$router.go(-1);
            }
            this.iABRef = cordova.InAppBrowser.open(`${this.currentQuiz.quiz_url}?email=${encodeURIComponent(this.user.user_email)}&iab=true`, '_blank', "location=no,toolbar=no,clearcache=yes,clearsessioncache=yes");
            this.loading = false;

            this.iABRef.addEventListener('message', (params) => {
                if(!params || !params.data) return;

                const { type } = params.data;

                switch(type) {
                    case 'exit':
                        this.$router.push({ path: '/' });
                        return this.iABRef.close();
                    case 'result':
                        this.$store.dispatch('quizzes/fetchQuizProfile');
                        this.$store.dispatch('quizzes/fetchOutfits');
                        this.$router.push({ path: '/quiz/result' });
                        return this.iABRef.close();
                }
            });
        },
        beforeDestroy() {
            if(this.iABRef) this.iABRef.close();
        },
        beforeRouteLeave(to, from, next) {
            if(!to.path.includes('/quiz')) {
                this.$store.commit({
                    type: 'footer/showFooter'
                });
            }
            next();
        },
    }
</script>

<style>

</style>